export const buyingGuide = {
  // -----
  bguide01: {
    title: "Roller blinds",
    description: [
      "Roller blinds are versatile, budget-friendly and stylish. With a choice of specialist fabrics, including blackout and moisture-resistant option they are ideal for kitchens, bathrooms and bedrooms.",
      "In uPVC windows, Roller blinds can be fitted into a Perfect Fit frame for a no-drill solution. Motorised controls are also available for easy operation.",
    ],
    content: [
      "Choice of stylish colours, prints and patterns",
      "Blackout and moisture-resistant fabrics",
      "Fits a wide range of window sizes",
      "No drill option for uPVC windows",
      "Motorised controls for easy operation"
    ],
    link: "/product/blinds/roller"
  },
  bguide02: {
    title: "Vertical blinds",
    description: [
      "Vertical blinds are made up of individual fabric louvres held together with chains or weights. The louvres can be tilted to maintain privacy while letting in light, or positioned flat to block out strong sun. They also concertina to one side when you want a clear view.",
      "Vertical blinds fit sloping windows and curved bays, and come in a range of performance fabrics like blackout, fire-retardant and easy clean PVC. They’re also one of the most cost-effective solutions for large windows, so a great choice for sliding glass or patio doors.",
    ],
    content: [
      "Individual fabric louvres that can be tilted to gently filter light",
      "A great choice for curved and sloping windows",
      "Versatile and cost-effective choice for very wide windows and glass doors",
      "Choice of performance fabrics for every room",
      "Great for privacy and flexible light control"
    ],
    link: "/product/blinds/vertical"
  },
  bguide03: {
    title: "Venetian blinds",
    description: [
      "Metal Venetian blinds consist of horizontal metal slats held together by cords. The slats either lie flat against the window to block out light, or tilt to let it gently filter through. When pulled right up, the slats create a slim profile that leaves your window free.",
      "Metal Venetian blinds are available in a selection of colours and finishes allowing you to create an individual look. If you have uPVC windows or sliding glass doors, they can fit inside Perfect Fit frames, which eliminate the need for cords.",
    ],
    content: [
      "Slats available in a choice of widths to suit a range of window sizes",
      "Metallic finish helps to enhance light levels",
      "Choose for flexible light control and privacy",
      "Matt, gloss and luxury metallic finishes for a contemporary look",
      "No drill solution for uPVC windows",
    ],
    link: "/product/blinds/venetian"
  },
  bguide04: {
    title: "Zebra blinds",
    description: [
      "Day and Night Roller blinds offer the best of both worlds when it comes to privacy and light control. Essentially this is a layered Roller blind, where overlapping sheer and opaque panels can be adjusted to mimic the look of open or closed slats. The overall look is softer than a Venetian blind and these blinds have the added benefit of optional motorisation.",
      "Day and Night Roller blinds are especially good for contemporary interiors, and wide windows that require daytime privacy.",
    ],
    content: [
      "Flexible light control - sheer and opaque options in a single blind",
      "Looks like a Roller blind – works like a Venetian blind",
      "Motorised control option",
      "Great for daytime privacy and flexible light control",
      "Good solution for wide windows",
    ],
    link: "/product/blinds/zebra"
  },
  bguide05: {
    title: "Eyelet heading",
    description: [
      "Eyelet curtain headings are threaded on to a pole through metal rings, with the curtains hanging in deep, uniform folds from the top to the bottom. This heading type is very fashionable in modern homes.",
    ],
    content: [
      "Great for any style and budget",
      "Creating simple, but eye-catching clean lines",
      "Making small rooms look bigger",
      "Customising colours and finishes",
    ],
    link: "/product/curtains/day"
  },
  bguide06: {
    title: "Pencil pleat heading",
    description: [
      "Pencil pleat curtain headings gather the fabric into semi-cylindrical rolls that resemble a line of pencils. The curtains will tumble freely to the floor. It’s a classic heading that goes with poles or tracks.",
    ],
    content: [
      "All our made-to-measure curtains are available with a pencil pleat header style",
      "Extra deep pencil pleat option available for taller windows",
      "Pencil pleat curtains can be fitted onto a curtain pole or track",
      "Versatile, budget friendly option",
    ],
    link: "/product/curtains/day"
  },
  bguide07: {
    title: "Pinch pleat heading",
    description: [
      "Pinch pleat curtain headings draw together lots of fabric, which is gathered in bunches and stitched to create a highly decorative finish featuring elegant folds flowing to the floor. You can have pinch pleat headings with either a pole or a track.",
    ],
    content: [
      "All our made-to-measure curtains are available with a pinch pleat header style",
      "Options for double pinch pleat and triple pinch pleat header",
      "Pinch pleat curtains can be fitted onto a curtain pole or track",
      "A versatile, great value option",
      "Everything taken care of for you",
    ],
    link: "/product/curtains/day"
  },
  bguide08: {
    title: "Wave heading",
    description: [
      "Wave curtain headings are perfect for an informal, relaxed feel. The curtain falls in soft, wave-like rippling folds allowing more of the fabric to be seen. Wave curtains are fitted to a slim track.",
    ],
    content: [
      "A wave header style allows curtains to drape in soft, relaxed folds",
      "Wave curtains are fitted to a specially designed, discreet track",
      "Wave curtains fall into neat folds so are a good option if you don’t have much space next to your windows",
      "A versatile, stylish solution to suit all budgets",
    ],
    link: "/product/curtains/day"
  },
  bguide09: {
    title: "Full height shutters",
    description: [
      "Our most popular and versatile shutter style. Each shutter panel is made to the full height of your window. Full height shutters give you a classic and sophisticated look, providing exceptional levels of privacy and light control. They suit all window styles and shapes and can be fitted to large expanses of glass, including patio doors.",
      "As with all our shutters, you can choose from a range of louvre widths. Smaller windows or period style homes usually suit a slimmer louvre width, whereas large windows in contemporary styled homes benefit from a wider louvre.",
    ],
    content: [
      "Choose from a range of wood stain or painted shades, including custom colours",
      "Waterproof options available for kitchens and bathrooms",
      "Louvres in the top and bottom sections can move together or independently",
      "Choose plantation shutters with louvres or solid shutters",
      "A versatile, stylish solution to suit all budgets",
    ],
    link: "/product/shutters/timber"
  },
  bguide10: {
    title: "Tier-on-tier shutters",
    description: [
      "A practical and stylish choice to beat the heat, our quality range of tier-on-tier shutters have top and bottom panels that open independently for great control over light and privacy. Our in-home service includes expert measuring and fitting included for a perfect finish and value you can measure.",
    ],
    content: [
      "Choose from a range of wood stain or painted shades, including custom colours",
      "Waterproof options available for kitchens and bathrooms",
      "Top and bottom sections can be adjusted independently",
      "Choose plantation shutters with louvres or solid shutters",
      "Reduce light glare, but allow in enough light to help you work or read",
      "Beneficial for rooms where privacy and light control are important",
      "Cost effective, sophisticated style",
    ],
    link: "/product/shutters/timber"
  },
  bguide11: {
    title: "Solid shutters",
    description: [
      "Solid shutters are a refined and elegant choice for any style of home or window. A great way to beat the heat in summer, or add extra insulation to your home in winter without compromising style.",
    ],
    content: [
      "The single panel design blocks out unwanted light during the day",
      "Adds an extra insulating layer helping to keep the heat in",
      "Can be added to a track and used as room dividers to provide extra privacy",
      "Choose plantation shutters with louvres or solid shutters",
      "A cost effective, sophisticated solution for any home",
      "Great choice for large expanses of glass such as sliding patio doors",
      "Create the illusion of a false wall when the shutters are closed",
    ],
    link: "/product/shutters/timber"
  },
  bguide12: {
    title: "Tracked shutters",
    description: [
      "Beat the heat with Tracked shutters. Ideal for wide windows, sliding or bi-fold doors, they slide open on a specially made track creating a smooth sliding mechanism. Our high quality range includes expert measuring and fitting - that’s what makes us great value.",
    ],
    content: [
      "Great for light and privacy control especially with bi-fold doors, or other expanses of glass",
      "Waterproof options available for bathroom and kitchens",
      "Perfect for dividing spaces to separate rooms and providing privacy",
      "The shutters concertina back neatly, allowing you to fully enjoy the view from your window",
      "A cost effective, sophisticated style for open plan living",
    ],
    link: "/product/shutters/timber"
  },
  bguide13: {
    title: "Shaped shutters",
    description: [
      "Beat the heat with shaped shutters. Perfect for transforming arched, triangular, circular or small windows, we can make and fit shutters to any size or shape with our made to measure service. Our shaped shutters come in all colour options, from natural wood stains to custom colours.",
    ],
    content: [
      "Light and privacy control for small or unusually shaped windows",
      "Completely customisable for almost all non-standard windows",
      "Waterproof options for kitchens or bathrooms",
      "Fully guaranteed for five years for peace of mind",
      "A cost effective, sophisticated solution for any window",
    ],
    link: "/product/shutters/timber"
  },
  bguideCurtain: {
    title: "How to choose the perfect curtains for your home",
    link: "/product/curtains/day",
    items: [
      {
        title: "Think about curtain fullness",
        content: "Different header types require different levels of fullness. Likewise, a thin sheer fabric may require more fabric – a greater fullness – than a thicker material to achieve a similar look.",
        image: "",
      },
      {
        title: "Choose how high to hang your curtains",
        content: "To add to your room’s sense of height, have your curtains fixed several inches above the top of the window frame. You can also take into consideration if there is a radiator near the window which can mean altering the curtain length.",
      },
      {
        title: "Choose the right curtain lining",
        content: "All of our curtains are lined as standard for a luxurious and full finish. There’s also the option for a thermal curtain lining, which will help insulate the home; or a blackout curtain lining, which will help prevent outside light coming inside through the window.",
      },
      {
        title: "Layer curtains with other window dressings",
        content: "For added effect, you can layer other products with curtains at your window. This could be for aesthetic or practical reasons. Layering different blinds with curtains is a great way to combine fabrics at a window to create a sense of depth by playing on textures and patterns. Or you might choose a blind to layer with curtains to increase the blackout effect or to enhance sound or heat insulation.",
      },
      {
        title: "Add light and bright Voile curtains",
        content: "Another option is layering curtains with voiles. The combination of a light voile with a full curtain looks fantastic, adding a delicate touch to a window.",
      },
      {
        title: "Finish with stylish accessories",
        content: "The finishing touches you choose are every bit as important as the fabric is to the end result. An in-home appointment with a Soho Blinds advisor gives you an opportunity to go through them all with an expert and to get a true understanding of the end result.",
      },
    ]
  },
};
